import $ from 'jquery';
import Flickity from 'flickity';

// Make an index of carousels for potential use later in theme editor
const carousels = {};
const carousels_mobile = {};

// The main function that actually initializes the carousels
const carouselInit = (section_id, $carousel, index) => {
  const slide_count = $carousel.children().length;

  if (slide_count < 1) {
    // Don't init pointless carousels with no slides
    return;
  }

  let object = carousels;
  if ($carousel.attr('id').indexOf('mobile') >= 0) {
    object = carousels_mobile;
  }

  const $data = $carousel.data();
  let prev_next_buttons = $data.prevNextButtons;
  let page_dots = $data.pageDots;
  let draggable = $data.draggable;

  if (slide_count === 1) {
    prev_next_buttons = false;
    page_dots = false;
    draggable = false;
  }
  
  object[section_id] = new Flickity($carousel[0], {
    initialIndex: index ? index : 0,
    prevNextButtons: prev_next_buttons,
    pageDots: page_dots,    
    wrapAround: $data.wrapAround,
    autoPlay: $data.autoPlay,
    pauseAutoPlayOnHover: $data.pauseAutoPlayOnHover,
    dragThreshold: window.theme.flickity.dragThreshold,
    adaptiveHeight: true,
    imagesLoaded: true,
    draggable,
  });

  object[section_id].on('change', () => {
    // This is now called 'heroCarouselDidChange' but leaving the old name for backwards-compatability
    $(document).trigger('heroCarouselChange', section_id);
    $(document).trigger('heroCarouselDidChange', section_id);
  });
  
  $carousel.css('overflow', 'visible');
};

export {
  carousels,
  carousels_mobile,
  carouselInit,
};